export const SET_TITLE = 'SET_TITLE' as const;
export const setTitle = (title: string) => ({
  type: SET_TITLE,
  title,
});
export type SetTitle = ReturnType<typeof setTitle>;

export const SET_CODE = 'SET_CODE' as const;
export const setCode = (code: string) => ({
  type: SET_CODE,
  code,
});
export type SetCode = ReturnType<typeof setCode>;

export const SET_ERROR_COUNTER = 'SET_ERROR_COUNTER' as const;
export const setErrorCounter = () => ({
  type: SET_ERROR_COUNTER,
});
export type SetErrorCounter = ReturnType<typeof setErrorCounter>;

export const RESET_ERROR_COUNTER = 'RESET_ERROR_COUNTER' as const;
export const resetErrorCounter = () => ({
  type: RESET_ERROR_COUNTER,
});
export type ResetErrorCounter = ReturnType<typeof resetErrorCounter>;

export const SET_ERROR_COUNTER_USERNAME = 'SET_ERROR_COUNTER_USERNAME' as const;
export const setErrorCounterUsername = (username: string) => ({
  type: SET_ERROR_COUNTER_USERNAME,
  username,
});
export type SetErrorCounteUsername = ReturnType<typeof setErrorCounterUsername>;

export type LoginPageActions = SetTitle | SetCode | SetErrorCounter | SetErrorCounteUsername | ResetErrorCounter;
